import { GridRowParams } from "@mui/x-data-grid";
import { UseRecordsOptions } from "../../api/useRecords";
import { RecordContextType } from "../../components/record/Record";

export const eegRecordingOptions = {
    fieldsToRemove: {
        fieldTypesToRemove: ["alias"],
    },
    groupsOptions: {
        fieldsWithExtraOptions: [
            {
                field: "eeg_data_file",
                fileFolder: "0b9562fd-4a45-409b-9053-397254d972e7",
                isValidFileExtension: (fileExtension: string) => {
                    return fileExtension === "tdt";
                },
                fileDeletingInterceptor: async ({ deleteFile, fileId, item, navigate }: any) => {
                    const evaluationId = item.eeg_evaluation.id;
                    const confirm = window.confirm(
                        "Tem a certeza que quer apagar este ficheiro? Irá apagar também este registo de EEG."
                    );
                    if (!confirm) return;
                    await deleteFile.mutateAsync({ id: fileId, entity: "eeg_recording" });
                    navigate(`/evaluations/${evaluationId}/eeg_recording`);
                },
                fileCreatingInterceptor: async ({ createFile, evaluationId, navigate }: any) => {
                    await createFile.mutateAsync({ id: evaluationId, entity: "evaluations" });
                    navigate(`/evaluations/${evaluationId}/eeg_recording`);
                },
            },
        ],
    },

    extraOptions: {
        sort: "-date_created",
    },

    dataGridOptions: {
        navigateToDetail: (arg: GridRowParams<any>) => createUrlForDetail(arg),
    },
    createRelatedParams: (params: RecordContextType | undefined) => createEegRecordingParams(params),
} as UseRecordsOptions;

const createEegRecordingParams = async (recordContext: RecordContextType | undefined) => {
    if (!recordContext?.item) return;

    if (recordContext.entity === "evaluations")
        return `[evaluations][id][*,eeg_session.start_date,eeg_session.treatment.client.client_id]=${recordContext.item.id}`;
};

const createUrlForDetail = (arg: GridRowParams<any>) => {
    if (!arg?.row) return null;
    const eegRecordingId = arg.row.id;

    return `/eeg_recording/${eegRecordingId}/eeg_analysis`;
};
